import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const types = {
  info: { color: '#3b82f6', bg: 'rgba(59, 130, 246, 0.1)', icon: 'ℹ️' },
  success: { color: '#10b981', bg: 'rgba(16, 185, 129, 0.1)', icon: '✅' },
  warning: { color: '#f59e0b', bg: 'rgba(245, 158, 11, 0.1)', icon: '⚠️' },
  danger: { color: '#ef4444', bg: 'rgba(239, 68, 68, 0.1)', icon: '🚨' }
};

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  margin: ${props => props.align === 'center' ? '0 auto' : '0'};
  background: ${props => types[props.type]?.bg || types.info.bg};
  border-left: 4px solid ${props => types[props.type]?.color || types.info.color};
  border-radius: 4px 12px 12px 4px;
  padding: 20px;
  display: flex;
  align-items: flex-start;
  gap: 15px;
`;

const Icon = styled.div`
  font-size: 24px;
`;

const Content = styled.div`
  flex: 1;
  h4 { margin: 0 0 5px 0; color: var(--text-primary); font-size: 16px; }
  p { margin: 0; color: var(--text-secondary); font-size: 14px; line-height: 1.5; }
`;

const NoticeBoxWidget = ({ node }) => {
  const t = node.style?.desktop?.type || 'info';

  return (
    <Wrapper align={node.style?.desktop?.align} width={node.style?.desktop?.width} type={t}>
      <Icon>{types[t]?.icon}</Icon>
      <Content>
        <h4>{node.content?.title || 'Wichtiger Hinweis'}</h4>
        <p>{node.content?.text || 'Aufgrund von Wartungsarbeiten kann es heute Nacht zu kurzen Unterbrechungen kommen.'}</p>
      </Content>
    </Wrapper>
  );
};

registry.register('notice_box', {
  label: 'Notice Box',
  icon: '📢',
  category: 'layout',
  defaultContent: {},
  defaultStyle: { desktop: { align: 'center', width: '100%', type: 'info' } },
  render: NoticeBoxWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Texte', fields: [{name:'content.title', label:'Titel', type:'text'}, {name:'content.text', label:'Hinweistext', type:'textarea'}] }] },
    { tab: 'style', groups: [{ title: 'Typ', fields: [{name:'style.desktop.type', label:'Typ', type:'select', options:[{label:'Info', value:'info'},{label:'Success', value:'success'},{label:'Warning', value:'warning'},{label:'Danger', value:'danger'}]}, {name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Zentriert', value:'center'},{label:'Links', value:'flex-start'}]}] }] }
  ]
});
